const goodsDispatch = {
    state:{
      // 当前页面选择类型
      goodsDispatchSetType:'1'
    },
    action:{
      getGoodsDispatchSetType({ commit }, data) {
        commit("SET_GOODS_DISPATCH_SET_TYPE", data);
      },
    },
    mutations: {
      SET_GOODS_DISPATCH_SET_TYPE:(state, val) => {
        state.goodsDispatchSetType = val
      },
    }
}
export default goodsDispatch
